import React from "react";

const VoucherCard = ({ value, applied, message, onChange, onApply, onRemove }) => (
  <section className="sy-flow-card">
    <div className="sy-flow-card-head">
      <h2 className="sy-flow-card-title">Voucher</h2>
      <span className="sy-flow-card-note">Optional</span>
    </div>

    <div className="sy-flow-card-body">
      <form
        className="sy-checkout-voucher"
        onSubmit={(event) => {
          event.preventDefault();
          if (!applied) onApply();
        }}
      >
        <input
          type="text"
          aria-label="Voucher code"
          placeholder="Enter a voucher code"
          value={applied || value}
          disabled={Boolean(applied)}
          onChange={(event) => onChange(event.target.value)}
        />

        {applied ? (
          <button type="button" className="sy-flow-btn sy-flow-btn-quiet" onClick={onRemove}>
            Remove
          </button>
        ) : (
          <button
            type="submit"
            className="sy-flow-btn sy-flow-btn-ghost"
            disabled={!value.trim()}
          >
            Apply
          </button>
        )}
      </form>

      {message && (
        <p
          className={`sy-checkout-voucher-message ${applied ? "is-applied" : "is-rejected"}`}
          role="status"
        >
          {message}
        </p>
      )}
    </div>
  </section>
);

export default VoucherCard;
